import './App.css';
import './App-850.css';
import React from 'react';
import { useState, useEffect, useRef } from 'react';
import Header from './components/header';
import FixBar from './components/fixbar';
import Footer from './components/footer';
import img1 from './assets/pacient-3d-cu-device.png';
import img2 from './assets/img2.png';
import img3 from './assets/img3.png';
import img4 from './assets/img4.png';
import img5 from './assets/img5.png';
import img6 from './assets/img6.png';
import img7 from './assets/img7.png';
import img8 from './assets/img8.png';
import {Success, Failed} from './components/alert';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DeleteAccountPage from './DeleteAccountPage';
import DeleteDataPage from './DeleteDataPage';


class LastChanges extends React.Component {
  render() {

    const changes = [
      {
        date: '2 Mar 2025',
        label: 'Adaugat versiune de internal testing pe Play Store. Butonul "Descarca aplicatie" acum redirectioneaza la acea pagina',
      },
      {
        date: '29 Sept 2024',
        label: 'Adaugare sectiunea "Conditii de viata" si "Antecedente" pentru specializarea osteopatie',
      },
      {
        date: '28 Sept 2024',
        label: 'Imbunatatiri design ecran e login. Fixat bug care apare la selectarea actiunii de back imediat dupa logare in aplicatie',
      },
      {
        date: '27 Sept 2024',
        label: 'Optimizari ale ecranului principal al unui pacient, pentru specializarea "Osteopatie": titlul primei sectiuni se numeste "Sedinte", nu se mai arata sectiunea de "Internari"',
      },
      {
        date: '25 Sept 2024',
        label: 'Imbunatatirea comportamentului si a mesajelor de eroare in cazul in care se incearca logarea sau deschiderea aplicatiei pe device fara legatura la internet',
      },
      {
        date: '10 Sept 2024',
        label: 'Pentru DOB la adaugare unui pacient accepta varste mult mai mari pentru pacientii maturi in cazul specializarii Osteopatiei',
      },
      {
        date: '5 Sept 2024',
        label: 'La specializarea "Osteopatie", la etapa de consultatie noua, apar 2 sectiuni noi numite "Test de excludere" si "Teste osteopatice pozitionale"',
      },
      {
        date: '4 Sept 2024',
        label: 'La selectia specializarii "Osteopat", interfata aplicatiei afiseaza fisa pacientului si sectiunile examinarii cu diverse modificari pentru a se adapta mai bine pentru nevoile acestei specializari',
      },
      {
        date: '26 Aug 2024',
        label: 'Afiseaza sectiuni pentru fisa generala a pacientului customizate pentru specializarea pediatrie sau osteopatie',
      },
      {
        date: '20 Aug 2024',
        label: 'Tratamentele accepta valori fractionare pentru valoarea dozei. Modificarea este valabila la adaugarea tratamentului pentru o examinare dar si in cadrul fisei pacientului',
      },
      {
        date: '13 Aug 2024',
        label: 'Sectiunile investigatiilor sunt descrise complet. Un user poate adauga o investigatie cu nume custom, pe lange cele predefinite',
      },
      {
        date: '12 Aug 2024',
        label: 'Un tratament general sau din cadrul unei examinari, poate avea comentarii introduse de user, pe langa restul de parametrii existenti. ',
      },
      {
        date: '9 Aug 2024',
        label: 'Fixat scorurile de la item-urile sectiunilor din cadrul examinarilor. Acest lucru determina afisarea corecta a descrierii unei sectiuni in documentul exportat sau in ecranul de vizualizare a unei examinari trecute.',
      },
      {
        date: '7 Aug 2024',
        label: 'Profilul userului are proprietatea "User Name". Acesta va aparea pe documentul PDF exportat.',
      },
      {
        date: '21 Iul 2024',
        label: 'Refacut design-ul iconitelor in intreaga aplicatie',
      },
      {
        date: '19 Iul 2024',
        label: 'Introducere feature nou: Facturi. Se pot adauga facturi sau sterge, genera PDF factura curenta sau regenera PDF de la o factura trecuta',
      },
      {
        date: '12 Iul 2024',
        label: 'Introducere feature nou: Programari. Se pot administra programarile pentru toti pacienti si urmari in primul ecran data urmatoarelor programari',
      },
    ]

    return (
      <div>
        <div className='title full-width sp-bt-2'>Ultimele modificari</div>
        <div className='full-width changes'>
          {changes.map((c, index) => {
            return (<div  key={'change' + index} className='change-row'>
                <div className='change-date'>{c['date']}</div>
                <div className='change-label'>{c['label']}</div>
            </div>)
          })}    
        </div>

      </div>
    )
  }
}

class ParticipateForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      isMedic: false,
      medicType: '',
      source: '',
      error: '',
      success: false,
      termsAndConditions: false,
    };
  }

  sendMessage = () => {
    let message = 'Email: ' + this.state.email;

    if (!!this.state.source) {
      message += '. Source: ' + this.state.source;
    }

    if (!!this.state.isMedic) {
      message += '. IsMedic: ' + this.state.isMedic;
    }

    if (this.state.isMedic) {
      message += '. Medic type: ' + this.state.medicType;
    }

    // Should fill in email
    if (!this.state.email) {
      this.setState({
        success: false,
        error: 'Trebuie completat email. Va vom contacta pentru a continua discutia folosind acest email.'
      });
      return;
    }

    if(!!this.state.isMedic && !this.state.medicType) {
      this.setState({
        success: false,
        error: 'Daca ati selectat ca sunteti medic, va rugam sa completati si campul pentru tipul de medic'
      });
      return;
    }

    if(!this.state.termsAndConditions) {
      this.setState({
        error: 'Este necesar sa acceptati termenii si conditiile testarii aplicatiei Art Medica pentru a trimite formularul'
      });
      return;
    }

    fetch('https://09mclyfv7k.execute-api.eu-central-1.amazonaws.com/prod/log_event', {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        type: 'event',
        name: 'Contact form',
        from: 'Art Medica',
        message: message,
      })
    }).then((response) => response.json().then((responseData) => {
      this.setState({
        email: '',
        source: '',
        isMedic: false,
        medicType: '',
        success: true,
      });
      
    }));
  }

  render() {
    return(
      <div>
        <div className='title full-width sp-bt-2'>Participare program testare</div>
        <div className='full-width'>
          Pentru participarea la testarea aplicatiei, va rugam sa completati formularul de mai jos si noi vom reveni in surt timp cu urmatorii pasi.
          Pe perioada testarii veti putea beneficia de aplicatie fara nici un cost si fara nici o limitare.
        </div>
        <div className='horizontal-space-20' />
        <form>
          <label>Email</label>
          <input name="email" type='email' placeholder='email@gmail.com'
            value={this.state.email}
            onChange={e => this.setState({ email: e.target.value })} />

          <div className='horizontal-space-10' />
          <div className='full-width row'>
            <div className="checkbox-wrapper-18">
              <div className="round">
                <input type="checkbox" id="check-medic" 
                  checked={this.state.isMedic} 
                  onChange={() => this.setState({isMedic: !this.state.isMedic})}/>
                <label htmlFor="check-medic"></label>
              </div>
            </div>
            <div onClick={() => this.setState({isMedic: !this.state.isMedic})}>Sunt medic</div>
          </div>

          <div className='horizontal-space-10' />
          <label>Specializare</label>
          <input name="specializare" type='text' placeholder='Medic pediatru'
            value={this.state.medicType}
            onChange={e => this.setState({ medicType: e.target.value })} />
          <div className='horizontal-space-10' />
          <label>De unde ati auzit de noi</label>

          <input name="source" 
            value={this.state.source}
            onChange={e => this.setState({ source: e.target.value })} />

          <div className='horizontal-space-10' />

          <div className='full-width row'>
            <div className="checkbox-wrapper-18">
              <div className="round">
                <input type="checkbox" id="check-conditions" 
                  checked={this.state.termsAndConditions} 
                  onChange={() => this.setState({termsAndConditions: !this.state.termsAndConditions})} />
                <label htmlFor="check-conditions"></label>
              </div>
            </div>
            <div onClick={() => this.setState({termsAndConditions: !this.state.termsAndConditions})}>Sunt de acord cu Termenii si Conditiile testarii aplicatiei Art Medica</div>
          </div>

          <div className='horizontal-space-10' />
          <div className='btn-body' onClick={() => this.sendMessage()}>Trimite</div>
      </form>

      {this.state.success && <Success hide={() => this.setState({success: false})}/>}
      {!!this.state.error && <Failed hide={() => this.setState({error: '', success: false})} content={this.state.error}/>}
      </div>
    )
  }
}

class LeftImageRow extends React.Component {
  render() {
    return (
      <div className='left-image-row-outer sp-tp-1v'>
        <div className={"left " + (this.props.data.smImage ? 'sm-image' : "") + (this.props.data.lgImage ? ' lg-image': "")}>
          <img alt={this.props.data.alt} src={this.props.data.image} />
        </div>

        <div className='right'>
          <div className='title sp-bt-2'>{this.props.data.title}</div>

          {this.props.data.text.length === 1 && <div>{this.props.data.text}</div>}
          
          {this.props.data.text.length > 1 && 
            <div className='items'>
              {
                this.props.data.text.map(
                  function(itemText, index) {
                    return <div key={index}>&#9882; {itemText}</div>
                  }
                )
              }
            </div>
            
          }

          {!!this.props.data.button && <div className='section-btn sp-tp-2'><div className='btn-body' onClick={() => this.props.participate()}>{this.props.data.button}</div></div>}
        </div>
      </div>  
    )
  }
}

class RightImageRow extends React.Component {
  render() {
    return (
      <div className='right-image-row-outer sp-tp-1v'>
        <div className='left'>
          <div className='title sp-bt-2'>{this.props.data.title}</div>

          {this.props.data.text.length === 1 && <div className='row-text'>{this.props.data.text}</div>}
          
          {this.props.data.text.length > 1 &&
            this.props.data.text.map(
              function(itemText, index) {
                return <div key={index}>{itemText}</div>
              }
            )
          }

          {!!this.props.data.button && <div className='section-btn sp-tp-2'><div className='btn-body'>{this.props.data.button}</div></div>}
        </div>

        <div className='right'>
          <img alt={this.props.data.alt} src={this.props.data.image} />
        </div>

      </div>  
    )
  }
}

// class Footer extends React.Component {
//   render() {
//     return (
//       <>
//         <div><Link to="/privacy">Privacy Page</Link></div>
//         <div><Link to="/delete-account">Delete Account</Link></div>
//         <div><Link to="/delete-data">Delete Data</Link></div>
//       </>
//     );
//   }
// }

class Content extends React.Component {

  render() {

    const dataRows = [
      {
        image: img1,
        alt: 'phone device',
        title: 'Sumar functionalitati',
        text: ['Monitorizare pacienti', 'Salvare date', 'Grafice de crestere', 'Evidenta programari', 'Administrare facturi', 'Export examinari si fisa pacient'],
        button: 'Doresc access',
        smImage: true,
      },
      {
        image: img2,
        alt: 'sections patients',
        title: 'Administrare pacienti',
        text: ['Operații de baza cu pacienți (adaugare, stergere), salvare informatii relevante despre starea medicala generala, urmarire tratament, salvare informatii internari trecute'],
        button: ''
      },
      {
        image: img3,
        alt: 'phone screens',
        title: 'Proces consultatie',
        text: ['Interfața este construită pe baza unei fișe de consultație reale. Aplicația este concepută sa ajute în procesul de consultatie si în același timp este intuitiva, ușor și rapid de folosit'],
        button: ''
      },
      {
        image: img4,
        alt: 'growth chart',
        title: 'Monitorizare pacient',
        text: ['Ofera modul de calcul automat al diversilor indici, de generare a graficelor de creștere de exemplu grafic greutate, calcul IMC/percentile. De asemenea, ajuta la urmarirea internarilor, investigațiilor și tratamentelor fiecărui pacient'],
        button: ''
      },
      {
        image: img5,
        alt: 'export pdf papers',
        title: 'Export PDF',
        text: ['Asigura export local sau trimitere pe e-mail a datelor din “Fișa pacientului” in format pdf. Se poate exporta fiecare examinare sau chiar intreaga gama de informatii intr-un singur document cuprinzand date generale despre pacient, istoricul investigatiilor si al tratamentelor si intreaga lista de examinari'],
        button: ''
      },
      {
        image: img6,
        alt: 'pediatrics and ostheopaty',
        title: 'Customizari pentru specializare',
        text: ['Interfata aplicatiei este ajustată pentru specializarea medicala selectata de utilizator.  Diverse elemente sunt vizibile doar daca sunt compatibile specializarii'],
        button: ''
      },
      {
        image: img7,
        alt: 'Invoice pdf',
        title: 'Generare facturi',
        text: ['Ofera modul pentru salvare date vanzator si cumparator, generare PDF factura potrivit pentru printare sau trimitere prin email catre pacient. Ofera posibilitate vizualizare istoricului facturilor'],
        button: '',
        lgImage: true,
      },
      {
        image: img8,
        alt: 'calendar and app section appointments',
        title: 'Gestionare programari pacienti',
        text: ['Exista posibilitatea de a salva direct in aplicatie data viitoarelor vizite ale pacientilor si de a observa vizitele deja stabilite pentru o usoare administrare a timpului'],
        button: ''
      },
    ];


    return (
      <div className='content'>
        <div className='section-spacer' />
        <div id='section-top' className='width-3-4 sp-bt-2'>
        Aplicatie mobila Android si Ios pentru administrare pacienti si digitalizarea procesului de consultatie
        </div>
        <div className='width-3-4 sp-bt-2'>
          Versiunea curenta {this.props.version}
        </div>

        <div className='width-3-4 sp-bt-2'>
        Aplicatia este in stadiul alfa de dezvoltare. Adaugam constant imbunatatiri si de aceea cautam consultanti pentru optimizarea serviciilor si a functionalitatilor oferite
        </div>

        <div className='section-btn sp-bt-2'>
          <div className='btn-body' onClick={() => this.props.participate()}>Doresc acces</div>
        </div>

        <div className='section-spacer' />
        <LeftImageRow data={dataRows[0]} participate={this.props.participate}/>
        <div className='section-spacer' />
        <RightImageRow data={dataRows[1]}/>
        <div className='section-spacer' />
        <LeftImageRow data={dataRows[2]}/>
        <div className='section-spacer' />
        <RightImageRow data={dataRows[3]}/>
        <div className='section-spacer' />
        <LeftImageRow data={dataRows[4]}/>
        <div className='section-spacer' />
        <RightImageRow data={dataRows[5]}/>
        <div className='section-spacer' />
        <LeftImageRow data={dataRows[6]}/>
        <div className='section-spacer' />
        <RightImageRow data={dataRows[7]}/>
        <div className='section-spacer' />
        <div className='section-spacer' />
        <LastChanges />
        <div className='section-spacer' />
        <div className='section-spacer' />
        <ParticipateForm />
        <div className='section-spacer' />
        <Footer />
        <div className='section-spacer' />
        <div className='section-spacer' />
      </div>
    )
  }
}

function HomePage() {


  const bottomRef = useRef(null);
  const [showFixBar, setShowFixBar] = useState(false);
  const handleScroll = () => {
      const position = window.scrollY;
      if (position > 200) {
        setShowFixBar(true);
      } else {
        setShowFixBar(false);
      }
  }

  const goToParticipateForm = () => {
    bottomRef.current?.scrollIntoView({behavior: 'smooth'});
  }

  const sendEvent = () => {
      if(window.location.hostname === 'localhost' || window.location.hostname.indexOf('192.168.0') === 0) {
          return;
      }

      if(!sessionStorage.getItem('visit')) {
          sessionStorage.setItem('visit', true);

          fetch('https://api.ipify.org?format=json')
              .then((ipResp) => ipResp.json().then((ipJson) => {
                  fetch('https://09mclyfv7k.execute-api.eu-central-1.amazonaws.com/prod/log_event', {
                      method: 'POST',
                      headers: {
                          "Content-Type": "application/json",
                      },
                      body: JSON.stringify({type: 'visit', name: 'artmedica.binary.ro', from: ipJson}),
                  }).then((response) => response.json().then((responseData) => {
                      sessionStorage.setItem('success', responseData.EventId);
                  }));
              })
          );
      }
  }


  useEffect(() => {
      window.addEventListener('scroll', handleScroll, { passive: true });
      sendEvent();

      return () => {
          window.removeEventListener('scroll', handleScroll);
      };
  }, []);

  return (
    <div className="App">
      <div id='grad'/>
        <Header participate={() => goToParticipateForm()} />
        {showFixBar && <FixBar participate={() => goToParticipateForm()} />}
        <Content participate={() => goToParticipateForm()} version='1.4.0+3'/>
        <div ref={bottomRef} />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route path="/delete-account" element={<DeleteAccountPage />} />
        <Route path="/delete-data" element={<DeleteDataPage />} />
      </Routes>

    </Router>
  );
}

export default App;
